import { HashLink } from "react-router-hash-link";

import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import Fade from "react-reveal/Fade";
import { useTranslation } from "react-i18next";

const ExpWithPicLeft = ({ smallTitle, title, content, imgUrl, imgHeight }) => {
  const { t, i18n } = useTranslation();
  return (
    <Grid
      maxWidth="md"
      container
      sx={{
        width: 1,
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        py: 10,
        ml: "auto",
        mr: "auto",
      }}
    >
      <Grid
        item
        md={6}
        sm={12}
        sx={{
          width: { md: "600px", sm: 1 / 2 },
          height: {
            md: "600px",
            sm: "300px",
          },
          backgroundImage: `url("https://images.unsplash.com/photo-1581091013158-5c7184f43b62?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80")`,
          backgroundSize: { md: "cover", sm: "100% 100%" },
        }}
      ></Grid>
      <Grid
        item
        md={6}
        sm={12}
        sx={{
          px: 4,
          py: { md: 6, sm: 10, xs: 10 },
          fontSize: "30px",
          backgroundColor: "#eef4f9",
          height: "600px",
          color: "#5f6566",
        }}
      >
        <Fade delay={300}>
          <Typography
            sx={{ fontSize: "22px", fontWeight: 800, color: "#102840" }}
          >
            {t("our_technology")}
          </Typography>
        </Fade>
        <Fade delay={400}>
          <Typography
            sx={{
              lineHeight: "170%",
              fontSize: "17px",
            }}
          >
            <Box
              sx={{
                fontSize: "17px",
                pt: 3,
                lineHeight: "1.6em",
                fontWeight: "bold",
                color: "#153a5b",
              }}
            >
              {t("hybrid_max")}
            </Box>
            <Box sx={{ fontSize: "14px", pt: 2 }}>
              {t("hybrid_max_exp")}
              <Box sx={{ color: "#153a5b", textDecoration: "underline" }}>
                <HashLink to="/technology#hybrid-max">
                  {t("learn_more")}
                </HashLink>
              </Box>
            </Box>
            <Box
              sx={{
                fontSize: "17px",
                pt: 3,
                lineHeight: "1.6em",
                fontWeight: "bold",
                color: "#153a5b",
              }}
            >
              {t("ultra_phenix")}
            </Box>
            <Box sx={{ fontSize: "14px", pt: 2 }}>
              {t("ultra_phenix_exp")}
              <Box sx={{ color: "#153a5b", textDecoration: "underline" }}>
                <HashLink to="/technology#ultra-phenix">
                  {t("learn_more")}
                </HashLink>
              </Box>
              <button
                className="custom_btn"
                style={{ width: "200px", marginTop: "35px" }}
              >
                <HashLink to="/products-cleansing#top">
                  {t("our_products")}
                </HashLink>
              </button>
            </Box>
          </Typography>
        </Fade>
      </Grid>
    </Grid>
  );
};

export default ExpWithPicLeft;
